import { UserActionType } from '@wix/ambassador-funnel-chatbot-v1-session/types';

import { IInitialChatData } from '../../../server/service/InitialChatData';
import { widgetSDK } from '../../sdk/widgetSDK';
import { logger } from '../../util/logger';
import { fedopsLogger, renderModel } from '../../util/renderModel';
import { HttpClientFactory } from '../httpClient';
import { addToQueue, debug, handleConflictStatus, threeDotsDelay } from './utils';

const { clientTopology, queryParams: query } = renderModel.get();

export enum SendUserActionError {
  network = 'NETWORK',
  timeout = 'TIMEOUT',
  other = 'OTHER',
}

export const sendUserAction = (
  action: UserActionType,
  conversationId: string | undefined,
  nodeId: string | undefined,
  httpClient: HttpClientFactory,
  parentUrl?: string,
) => {
  return widgetSDK.getContext(parentUrl).then((context) => {
    const requestStartedTs = Date.now();
    fedopsLogger.interactionStarted('fetching-user-action');
    return httpClient
      .getInstance()
      .post<IInitialChatData>(clientTopology.userActionUrl, {
        action,
        conversationId,
        nodeId,
        context,
      })
      .then((res) => threeDotsDelay(requestStartedTs).then(() => res))
      .then(handleConflictStatus)
      .then(addToQueue)
      .then((res) => {
        fedopsLogger.interactionEnded('fetching-user-action');
        return res;
      })
      .then(debug)
      .catch(async (error) => {
        fedopsLogger.interactionEnded('fetching-user-action');
        const errorMessage = 'fail to post user action';
        logger.error({
          message: errorMessage,
          error,
          callParams: {
            action,
            query,
          },
        });
        let errorType = SendUserActionError.other;

        if (!error.response) {
          errorType = SendUserActionError.network;
        } else if (error.response.status === 504) {
          errorType = SendUserActionError.timeout;
        }

        return threeDotsDelay(requestStartedTs).then(() => Promise.reject(errorType));
      });
  });
};
